import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'tvt-logistics-india-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  loading: boolean = false;
  constructor(public http: HttpClient, private _snackBar: MatSnackBar) {}

  ngOnInit(): void {}

  onSubmit(name, email, msg_subject, phone_number, message, event) {
    if (name.value && email.value && msg_subject.value && message.value) {
      event.preventDefault();
      this.loading = true;
      const body = {
        name: name.value,
        email: email.value,
        subject: msg_subject.value,
        phoneNumber: phone_number.value,
        message: message.value,
        type: 'inquiry',
      };

      this.http
        .post(
          'https://ci9ms1wdj8.execute-api.ap-south-1.amazonaws.com/v1/send',
          JSON.stringify(body)
        )
        .subscribe(
          (data) => {
            this.loading = false;
            this._snackBar.open('Message Sent Successfully', null, {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: 'custom-snackbar-success',
            });
            window.location.reload();
          },
          (error) => {
            this.loading = false;
            this._snackBar.open(error.message, null, {
              duration: 5000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: 'custom-snackbar-error',
            });
          }
        );
    }
  }
}
